import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { setCredentials, logOut } from "../../features/auth/authSlice";

const baseQuery = fetchBaseQuery({
  // baseUrl: "https://devordertracker.quantumfoundry.co.uk/api/v1",
  //baseUrl: 'https://localhost:44441/api/v1',
  baseUrl: `${process.env.PUBLIC_URL}/api/v1`,
  credentials: "include",
  prepareHeaders: (headers, { getState }) => {
    const token = getState().auth.token;
    if (token) {
      headers.set("authorization", `Bearer ${token}`);
    }
    return headers;
  },
});

const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result?.meta?.response?.status === 401) {
    console.warn("sending refresh token");
    // send refresh token to get new access token
    const refreshResult = await baseQuery(
      "/Auth/refresh-token",
      api,
      extraOptions,
    );
    if (refreshResult?.data) {
      const user = api.getState().auth.user;
      // store the new token
      api.dispatch(setCredentials({ ...refreshResult.data, user }));
      // retry the original query with new access token
      result = await baseQuery(args, api, extraOptions);
    } else {
      api.dispatch(logOut());
    }
  }
  return result;
};

export const apiSlice = createApi({
  reducerPath: "api",
  baseQuery: baseQueryWithReauth,
  tagTypes: [
    "Order",
    "Employee",
    "Meeting",
    "Phone",
    "OrderSummary",
    "MeetingSummary",
    "PhoneSummary",
    "SalesChart",
    "BookedOrdersChart",
    "IndividualTargetsChart",
    "Notification",
    "CompanyTargetsChart",
    "CompanyTeamTargets",
  ],
  endpoints: (builder) => ({}),
});
